export default {

    postAddNewTask: function(task) {
        return axios.post('/api/tasks',
            task, {successHandle: true},
        );
    },
    postUpdateProjectTask: function(response) {
        return axios.put('/api/tasks/' + response.task.id,
            response.task, {successHandle: true},
        );
    },
    postDeleteProjectTask: function(response) {
        return axios.delete('/api/tasks/' + response.task.id,
            response.task, {successHandle: true},
        );
    },
    postUpdateProject: function(response) {
        return axios.put('/api/projects/' + response.project.id,
            response.project, {successHandle: true},
        );
    },
}
